const stylesWebcomponent = `
  :host {
    font-family: Roboto, "Segoe UI VSS (Regular)", "Segoe UI", -apple-system, BlinkMacSystemFont, Roboto, "Helvetica Neue", Helvetica, Ubuntu, Arial, Tahoma, Verdana, sans-serif;
  } 
  .monitor-apps {
    display: block;
    background-color: #ffff;
    width: fit-content;
    min-height: calc(40px + 2.5rem);
  }
  .monitor-apps__title {
    font-size: 1.2rem;
    margin: 0;
    margin-bottom: .5rem;
  }
  .monitor-apps__content {
    position: relative;
    width: 100%;
    height: fit-content;
    min-height: 60px;
    max-height: 10rem;
    overflow: auto;
    scrollbar-width: thin;
    scrollbar-color: #89a1ac #efefef;
  }
  .service {
    width: 100%;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    margin-bottom: .5rem;
  }
  .state-icon {
    width: 1rem;
    height: 1rem;
    border-radius: 50%;
    margin-right: 1rem;
    position: relative;
  }
  .state-icon--ok {
    background-color: #689F38;
  }
  .state-icon--ko {
    background-color: #C02B2F;
  }
  .spinner {
    background-color: #ffffff;
    width: 100%;
    height: 100%;
    z-index: 999;
  }
  .spinner::before {
    border: 2px solid #f3f3f3;
    border-radius: 50%;
    border-top: 2px solid #005da3;
    content: " ";
    display: block;
    height: 40px;
    left: 50%;
    margin-left: -25px;
    margin-top: -25px;
    position: absolute;
    top: 50%;
    width: 40px;
    animation: spin 1.5s linear infinite;
  }
  @-webkit-keyframes spin {
    0%   {-webkit-transform: rotate(0deg);}
    100% {-webkit-transform: rotate(360deg);}
  }
  @keyframes spin {
    0%   {transform: rotate(0deg);}
    100% {transform: rotate(360deg);}
  }
  .no-services {
    min-height: 60px;
    display: flex;
    justify-content: center;
    align-items: center;
  }
`;

const stylesTooltip = `
.monitor-apps-tooltip {
    visibility: hidden;
    width: fit-content;
    max-width: 20rem;
    padding: 0.5rem;
    background-color: rgb(13, 63, 101);
    color: white;
    word-wrap: break-word;
    position: absolute;
    z-index: 99;
    transition: opacity 0.2s;
    opacity: 0;
  }
  .monitor-apps-tooltip::after {
    content: " ";
    position: absolute;
    border-width: 5px;
    border-style: solid;
  }
  .monitor-apps-tooltip-left::after {
    top: 50%;
    left: 100%;
    margin-top: -5px;
    border-color: transparent transparent transparent rgb(13, 63, 101);
  }
  .monitor-apps-tooltip-right::after {
    top: 50%;
    right: 100%;
    margin-top: -5px;
    border-color: transparent rgb(13, 63, 101) transparent transparent;
  }
  .monitor-apps-tooltip-top::after {
    left: 50%;
    bottom: 100%;
    margin-left: -5px;
    border-color: rgb(13, 63, 101) transparent transparent transparent;
  }
  .monitor-apps-tooltip-bottom::after {
    left: 50%;
    top: 100%;
    margin-left: -5px;
    border-color: transparent transparent rgb(13, 63, 101) transparent;
  }
  .monitor-apps-tooltip.visible {
    opacity: 1;
    visibility: visible;
  }
`

export { stylesWebcomponent, stylesTooltip };